<template>
    <div class="card position-sticky mt-0 ps-4">
        <p class="font-weight-bold mt-3 p-header lead mb-0 p-2 mb-1">Hissəli ödəniş cədvəli</p>
        
        <div class="p-0 pt-4 mb-0 pb-0" style="margin-bottom: 0 !important;">
            <button v-if="priv?.canAddNew" type="button" class="btn mt-0 mb-0 me-2 bg-gradient-success"
                @click="OpenDialog(0, false, null, 'LIST2')">
                <span class="btn-text"> <i class="fa fa-plus" style="font-weight:bolder;"></i>&nbsp;&nbsp;Təzə
                    yazı</span>
            </button> 
            <button type="button" class="btn mt-0 mb-0" @click="GetLists2">
                <span class="btn-text">
                    <i class="fa fa-sync" style="font-weight:bolder;"></i>&nbsp;&nbsp;Yeniləmək</span>
            </button>
            <br />
            <div class="card-body px-0 pt-2 pb-3" v-loading="loading2">
                <Table2 :priv="priv" @open-dialog="OpenDialog" @get-data="GetLists2" :data="data2"></Table2>
            </div>
        </div>
        <p class="font-weight-bold mt-3 p-header lead mb-0 p-2 mb-1">Ödəniş</p>
        
        <div class="p-0 pt-4 mb-0 pb-0" style="margin-bottom: 0 !important;">
            <!-- <button type="button" class="btn mt-0 mb-0 bg-gradient-success"
                @click="OpenDialog(0, false, null, 'LIST3')">
                <span class="btn-text"> <i class="fa fa-plus" style="font-weight:bolder;"></i>&nbsp;&nbsp;Təzə
                    yazı</span>
            </button>
            &nbsp;&nbsp; -->
            <button type="button" class="btn mt-0 mb-0" @click="GetLists3">
                <span class="btn-text">
                    <i class="fa fa-sync" style="font-weight:bolder;"></i>&nbsp;&nbsp;Yeniləmək</span>
            </button>
            <br />
            <div class="card-body px-0 pt-2 pb-3" v-loading="loading3">
                <Table3 @open-dialog="OpenDialog" @get-data="GetLists3" :data="data3"></Table3>
            </div>
        </div>
    </div>

    <el-dialog :close-on-click-modal="false" v-model="this.list2.dialogVis" width="15%"
        :title="this.editing ? 'Şablon dəyişilməsi' : 'Yeni şablon'" modal-class="modal-class" :destroy-on-close="true">
        <list-dialog-2 :object="list2.object" :editing="editing" @close-dialog="this.list2.dialogVis = false"
            @insert-dialog="Insert"></list-dialog-2>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" v-model="this.list3.dialogVis" width="20%"
        :title="this.editing ? 'Şablon dəyişilməsi' : 'Yeni şablon'" modal-class="modal-class" :destroy-on-close="true">
        <list-dialog-3 :object="list3.object" :editing="editing" @close-dialog="this.list3.dialogVis = false"
            @insert-dialog="Insert"></list-dialog-3>
    </el-dialog>
</template>
<script>
import Table2 from "./Components/Tables/Table2.vue";
import Table3 from "./Components/Tables/Table3.vue"; 
import ListDialog2 from "./Components/Dialogs/ListDialog2.vue";
import ListDialog3 from "./Components/Dialogs/ListDialog2.vue";


export default {
    components: {
        ListDialog2,
        ListDialog3,
        Table2,
        Table3
    },
    props: {
        priv: Object
    },
    data() {
        return {
            loading2: null,
            loading3: null,
            data2: [
                {paySum: 150, payDateStr: '05.05.2025'},
                {paySum: 150, payDateStr: '05.06.2025'},
                {paySum: 150, payDateStr: '05.07.2025'},
                {paySum: 150, payDateStr: '05.08.2025'},
                {paySum: 150, payDateStr: '05.09.2025'},
                {paySum: 150, payDateStr: '05.10.2025'},
                {paySum: 150, payDateStr: '05.11.2025'},
                {paySum: 150, payDateStr: '05.12.2025'},
                {paySum: 150, payDateStr: '05.01.2026'},
                {paySum: 150, payDateStr: '05.02.2026'},
                {paySum: 150, payDateStr: '05.03.2026'},
            ],
            data3: [],
            list2: {
                dialogVis: false,
                object: null,
            },
            list3: {
                dialogVis: false,
                object: null
            },
        }
    },
    methods: {
        GetLists2() { 
            //None
        },
        GetLists3() { 
            //None
        },
        Insert() {
            if (this.type == 'LIST2') {
                this.list2.dialogVis = false
                this.GetLists2()
            } else if (this.type == 'LIST3') {
                this.list3.dialogVis = false
                this.GetLists3()
            }
        },
        OpenDialog(index, edit, object, type) {
            this.type = type
            if (this.type == 'LIST2') {
                this.list2.dialogVis = true
                this.list2.object = object
            }  else if (this.type == 'LIST3') {
                this.list3.dialogVis = true
                this.list3.object = object
            }
            this.editing = edit
        }
    },
    mounted() {
        this.GetLists2()
        this.GetLists3()
    }
}
</script>